import { render, staticRenderFns } from "./star-rating-input.vue?vue&type=template&id=1dd13d9c&scoped=true"
import script from "./star-rating-input.vue?vue&type=script&lang=js"
export * from "./star-rating-input.vue?vue&type=script&lang=js"
import style0 from "./star-rating-input.vue?vue&type=style&index=0&id=1dd13d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd13d9c",
  null
  
)

export default component.exports